<template>
  <async-btn
    :task="task"
    :icon="icon"
    :label="label"
    :color="color"
    text-color="body"
    unelevated
    rounded
    no-caps
    @click="toggle"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReconnectRequest } from '@/social/types';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { HasTaskMixin } from '@/mixins';
import { enableReminders, disableReminders } from '.';

interface Data {
  task: Promise<ReconnectRequest>|null,
}

export default defineComponent({
  emits: ['update:request'],
  mixins: [HasTaskMixin],
  components: {
    AsyncBtn,
  },
  props: {
    request: {
      type: Object as () => ReconnectRequest,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    icon(): string {
      return this.request.remindersEnabled ? 'fa fa-bell' : 'fa fa-bell-slash';
    },
    label(): string {
      return this.request.remindersEnabled ? 'Disable Reminders' : 'Enable Reminders';
    },
    color(): string {
      return this.request.remindersEnabled ? 'yellow-1' : 'green-1';
    },
  },
  methods: {
    toggle(): void {
      if (this.request.remindersEnabled) {
        this.task = disableReminders(this.request.id);
      } else {
        this.task = enableReminders(this.request.id);
      }

      this.task.then((request) => {
        this.$emit('update:request', request);
      });
    },
  },
});
</script>
